/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  import/no-commonjs,
  no-useless-escape
*/
module.exports = [
  {
    url: '\/',
    text: 'Home',
    options: {
      mobileMenuOnly: true,
    },
  },
  {
    url: '\/index.php\/info\/tour',
    text: 'Tour',
  },
  {
    url: '\/index.php\/info\/pricing',
    text: 'Pricing',
  },
  {
    url: '\/index.php\/info\/tour#googleIntegrations',
    text: 'Google',
  },
  {
    url: '\/index.php\/api',
    text: 'API',
  },
  {
    url: '\/index.php\/info\/resources',
    text: 'Resources',
  },
  {
    url: '\/index.php\/info\/press',
    text: 'Press',
  },
  {
    url: 'http:\/\/blog.hellosign.com\/',
    text: 'Blog',
  },
  {
    url: 'http:\/\/faq.hellosign.com',
    text: 'Help',
  },
];
